module.exports = __webpack_public_path__ + "img/slogn.b55ed963.png";